var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/common/data/is.ts
function isObject(obj) {
  return obj != null && typeof obj === "object";
}
__name(isObject, "isObject");
function isPrimitive(obj) {
  return Object(obj) !== obj;
}
__name(isPrimitive, "isPrimitive");
function isArray(obj) {
  return Array.isArray(obj);
}
__name(isArray, "isArray");
function isRecord(obj) {
  return isObject(obj) && !isArray(obj);
}
__name(isRecord, "isRecord");
function isString(obj) {
  return typeof obj === "string";
}
__name(isString, "isString");
function isNumber(obj) {
  return typeof obj === "number";
}
__name(isNumber, "isNumber");
function isInteger(obj) {
  return typeof obj === "number" && Number.isInteger(obj);
}
__name(isInteger, "isInteger");
function isSafeInteger(obj) {
  return typeof obj === "number" && Number.isSafeInteger(obj);
}
__name(isSafeInteger, "isSafeInteger");
function isBoolean(obj) {
  return typeof obj === "boolean";
}
__name(isBoolean, "isBoolean");
function isNullOrUndefined(obj) {
  return obj == null;
}
__name(isNullOrUndefined, "isNullOrUndefined");

// src/common/data/deep.ts
function deepEqual(a, b, hash = /* @__PURE__ */ new WeakSet()) {
  if (a === b) {
    return true;
  }
  if (hash.has(b)) {
    return true;
  }
  if (!isPrimitive(b)) {
    hash.add(b);
  }
  if (!(a instanceof Object) || !(b instanceof Object)) {
    return false;
  }
  if (a.constructor !== b.constructor) {
    return false;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (let p in a) {
    if (!a.hasOwnProperty(p)) {
      continue;
    }
    if (!b.hasOwnProperty(p)) {
      return false;
    }
    let aa = a[p];
    let bb = b[p];
    if (!deepEqual(aa, bb, hash)) {
      return false;
    }
  }
  for (let p in b) {
    if (b.hasOwnProperty(p) && !a.hasOwnProperty(p)) {
      return false;
    }
  }
  return true;
}
__name(deepEqual, "deepEqual");
function deepMerge(target, ...sources) {
  for (let source of sources) {
    if (!isObject(target)) {
      target = {};
    }
    if (source == null)
      continue;
    Object.keys(source).forEach((key) => {
      const targetValue = target[key];
      const sourceValue = source[key];
      if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
        target[key] = targetValue.concat(sourceValue);
      } else if (isObject(targetValue) && isObject(sourceValue)) {
        target[key] = deepMerge(Object.assign({}, targetValue), sourceValue);
      } else {
        target[key] = sourceValue;
      }
    });
  }
  return target;
}
__name(deepMerge, "deepMerge");

// src/common/log-console.ts
function LoggerConsoleHandler(opt = {}) {
  const {
    level = void 0,
    filter = void 0,
    colors = true,
    levelHelper = false,
    nameBrackets = true,
    padding = 16
  } = opt;
  const matchesNamespace = useNamespaceFilter(filter);
  const matchesLevel = useLevelFilter(level);
  return (msg) => {
    if (!matchesLevel(msg.level))
      return;
    if (!matchesNamespace(msg.name))
      return;
    let name = msg.name ? `[${msg.name}]` : "";
    switch (msg.level) {
      case 1 /* info */:
        console.info(`I|*   ${name}`, ...msg.messages);
        break;
      case 2 /* warn */:
        console.warn(`W|**  ${name}`, ...msg.messages);
        break;
      case 3 /* error */:
        console.error(`E|*** ${name}`, ...msg.messages);
        break;
      default:
        console.debug(`D|    ${name}`, ...msg.messages);
        break;
    }
  };
}
__name(LoggerConsoleHandler, "LoggerConsoleHandler");

// src/common/log-base.ts
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2[LogLevel2["all"] = -1] = "all";
  LogLevel2[LogLevel2["debug"] = 0] = "debug";
  LogLevel2[LogLevel2["info"] = 1] = "info";
  LogLevel2[LogLevel2["warn"] = 2] = "warn";
  LogLevel2[LogLevel2["error"] = 3] = "error";
  LogLevel2[LogLevel2["fatal"] = 4] = "fatal";
  LogLevel2[LogLevel2["off"] = Infinity] = "off";
  return LogLevel2;
})(LogLevel || {});
var LogLevelAlias = {
  "*": -1 /* all */,
  a: -1 /* all */,
  all: -1 /* all */,
  d: 0 /* debug */,
  dbg: 0 /* debug */,
  debug: 0 /* debug */,
  i: 1 /* info */,
  inf: 1 /* info */,
  info: 1 /* info */,
  w: 2 /* warn */,
  warn: 2 /* warn */,
  warning: 2 /* warn */,
  e: 3 /* error */,
  err: 3 /* error */,
  error: 3 /* error */,
  fatal: 4 /* fatal */,
  off: Infinity /* off */,
  "-": Infinity /* off */
};
function LoggerContext(prefix = "") {
  let logHandlers = [LoggerConsoleHandler()];
  let logAssertLevel = 2 /* warn */;
  let logCheckNamespace = /* @__PURE__ */ __name((name) => true, "logCheckNamespace");
  let logLock = false;
  let logFactory = LoggerBaseFactory;
  function LoggerBaseFactory(name = "") {
    log.extend = function(prefix2) {
      return logFactory(name ? `${name}:${prefix2}` : prefix2);
    };
    const emit = /* @__PURE__ */ __name((msg) => {
      if (log.active === true) {
        if (msg.level >= Logger2.level && msg.level >= log.level) {
          if (logCheckNamespace(name)) {
            for (let handler of logHandlers) {
              if (handler)
                handler(msg);
            }
          }
        }
      }
    }, "emit");
    function log(...messages) {
      emit({
        name,
        messages,
        level: 0 /* debug */
      });
    }
    __name(log, "log");
    log.active = true;
    log.level = -1 /* all */;
    log.debug = function(...messages) {
      emit({
        name,
        messages,
        level: 0 /* debug */
      });
    };
    log.info = function(...messages) {
      emit({
        name,
        messages,
        level: 1 /* info */
      });
    };
    log.warn = function(...messages) {
      emit({
        name,
        messages,
        level: 2 /* warn */
      });
    };
    log.error = function(...messages) {
      emit({
        name,
        messages,
        level: 3 /* error */
      });
    };
    log.assert = function(cond, ...messages) {
      if (!cond) {
        if (typeof console !== void 0) {
          if (console.assert) {
            console.assert(cond, ...messages);
          } else {
            console.error(`Assert did fail with: ${cond}`, ...messages);
          }
        }
        emit({
          name,
          messages: messages || [`Assert did fail with: ${cond}`],
          level: logAssertLevel
        });
      }
    };
    log.assertEqual = function(value, expected, ...args) {
      let equal = deepEqual(value, expected);
      if (!equal) {
        log.assert(equal, `Assert did fail. Expected ${expected} got ${value}`, expected, value, ...args);
      }
    };
    log.assertNotEqual = function(value, expected, ...args) {
      let equal = deepEqual(value, expected);
      if (equal) {
        log.assert(equal, `Assert did fail. Expected ${expected} not to be equal with ${value}`, expected, value, ...args);
      }
    };
    return log;
  }
  __name(LoggerBaseFactory, "LoggerBaseFactory");
  function Logger2(name = "") {
    return logFactory(name);
  }
  __name(Logger2, "Logger");
  Logger2.registerHandler = function(handler) {
    logHandlers.push(handler);
  };
  Logger2.setFilter = function(namespaces) {
    logCheckNamespace = useNamespaceFilter(namespaces);
  };
  Logger2.setLock = (lock = true) => logLock = lock;
  Logger2.setHandlers = function(handlers = []) {
    if (logFactory !== LoggerBaseFactory) {
      logFactory = LoggerBaseFactory;
    }
    if (logLock)
      return;
    logHandlers = [...handlers].filter((h) => typeof h === "function");
  };
  Logger2.level = -1 /* all */;
  Logger2.setLogLevel = function(level = -1 /* all */) {
    if (logLock)
      return;
    Logger2.level = level;
  };
  Logger2.setFactory = function(factory) {
    if (logLock)
      return;
    logFactory = factory;
  };
  return Logger2;
}
__name(LoggerContext, "LoggerContext");

// src/common/log-filter.ts
function getNamespaceFilterString(defaultNamespaceFilter2) {
  if (defaultNamespaceFilter2 === true || defaultNamespaceFilter2 === "true" || defaultNamespaceFilter2 === "1" || typeof defaultNamespaceFilter2 === "number" && defaultNamespaceFilter2 !== 0) {
    defaultNamespaceFilter2 = "*";
  } else if (defaultNamespaceFilter2 === false || defaultNamespaceFilter2 === "false" || defaultNamespaceFilter2 === 0 || defaultNamespaceFilter2 === "0" || defaultNamespaceFilter2 == null || defaultNamespaceFilter2 === "null" || defaultNamespaceFilter2 === "undefined") {
    defaultNamespaceFilter2 = "";
  } else {
    defaultNamespaceFilter2 = String(defaultNamespaceFilter2);
  }
  return defaultNamespaceFilter2;
}
__name(getNamespaceFilterString, "getNamespaceFilterString");
var _a, _b;
var defaultNamespaceFilter = getNamespaceFilterString(typeof process !== "undefined" ? (_a = process.env.ZEED) != null ? _a : process.env.DEBUG : typeof localStorage !== "undefined" ? (_b = localStorage.zeed) != null ? _b : localStorage.debug : "*");
function useNamespaceFilter(filter = defaultNamespaceFilter) {
  let fn;
  let reject = [];
  let accept = [];
  if (!filter) {
    fn = /* @__PURE__ */ __name(function(name) {
      return false;
    }, "fn");
  } else if (filter === "*") {
    fn = /* @__PURE__ */ __name(function(name) {
      return true;
    }, "fn");
  } else {
    let i;
    const split = filter.split(/[\s,]+/);
    const len = split.length;
    for (i = 0; i < len; i++) {
      if (!split[i]) {
        continue;
      }
      let template = split[i].replace(/\*/g, ".*?");
      if (template[0] === "-") {
        reject.push(new RegExp("^" + template.substr(1) + "$"));
      } else {
        accept.push(new RegExp("^" + template + "$"));
      }
    }
    fn = /* @__PURE__ */ __name(function(name) {
      if (reject.length === 0 && accept.length === 0) {
        return true;
      }
      let i2, len2;
      for (i2 = 0, len2 = reject.length; i2 < len2; i2++) {
        if (reject[i2].test(name)) {
          return false;
        }
      }
      for (i2 = 0, len2 = accept.length; i2 < len2; i2++) {
        if (accept[i2].test(name)) {
          return true;
        }
      }
      return false;
    }, "fn");
  }
  fn.accept = accept;
  fn.reject = reject;
  fn.filter = filter;
  return fn;
}
__name(useNamespaceFilter, "useNamespaceFilter");
var _a2, _b2, _c, _d;
var defaultLevelFilter = typeof process !== "undefined" ? (_b2 = (_a2 = process.env.ZEED_LEVEL) != null ? _a2 : process.env.LEVEL) != null ? _b2 : process.env.DEBUG_LEVEL : typeof localStorage !== "undefined" ? (_d = (_c = localStorage.zeed_level) != null ? _c : localStorage.level) != null ? _d : localStorage.debug_level : void 0;
function useLevelFilter(filter = defaultLevelFilter) {
  let filterLevel = -1 /* all */;
  if (typeof filter === "string") {
    const l = LogLevelAlias[filter.toLocaleLowerCase().trim()];
    if (l != null)
      filterLevel = l;
  } else if (typeof filter === "number") {
    filterLevel = filter;
  }
  return (level) => level >= filterLevel;
}
__name(useLevelFilter, "useLevelFilter");

// src/common/global.ts
function _global() {
  if (typeof self !== "undefined")
    return self;
  if (typeof window !== "undefined")
    return window;
  if (typeof global !== "undefined")
    return global;
  if (typeof globalThis !== "undefined")
    return globalThis;
  throw new Error("unable to locate global object");
}
__name(_global, "_global");
function getGlobalContext() {
  let gcontext = _global();
  if (gcontext._zeedGlobal == null) {
    gcontext._zeedGlobal = {};
  }
  return gcontext._zeedGlobal;
}
__name(getGlobalContext, "getGlobalContext");

// src/common/log.ts
var globalLogger;
function getLoggerContext() {
  let logger = LoggerContext();
  logger.setHandlers([LoggerConsoleHandler()]);
  return logger;
}
__name(getLoggerContext, "getLoggerContext");
try {
  let _global2 = getGlobalContext();
  if (_global2 != null) {
    if ((_global2 == null ? void 0 : _global2.logger) == null) {
      globalLogger = getLoggerContext();
      _global2.logger = globalLogger;
    } else {
      globalLogger = _global2.logger;
    }
  } else {
    globalLogger = getLoggerContext();
  }
} catch (e) {
  globalLogger = getLoggerContext();
}
var Logger = globalLogger;

// src/common/time.ts
var getTimestamp = /* @__PURE__ */ __name(() => Date.now(), "getTimestamp");
function formatMilliseconds(ms) {
  return ms > 999 ? (ms / 1e3).toFixed(1) + "s" : ms.toFixed(2) + "ms";
}
__name(formatMilliseconds, "formatMilliseconds");
function parseDate(...dateCandidates) {
  for (let dateCandidate of dateCandidates) {
    if (dateCandidate instanceof Date) {
      return dateCandidate;
    }
    if (typeof dateCandidate === "string") {
      let date = null;
      if (dateCandidate.includes(":")) {
        try {
          date = new Date(dateCandidate);
        } catch (err) {
        }
      }
      if (!(date instanceof Date)) {
        let m = /(\d\d\d\d)-(\d\d)-(\d\d)/.exec(dateCandidate);
        if (m) {
          date = new Date(+m[1], +m[2] - 1, +m[3], 12, 0);
        }
      }
      if (date instanceof Date) {
        return date;
      }
    }
  }
}
__name(parseDate, "parseDate");

export {
  __spreadValues,
  __spreadProps,
  __name,
  isObject,
  isPrimitive,
  isArray,
  isRecord,
  isString,
  isNumber,
  isInteger,
  isSafeInteger,
  isBoolean,
  isNullOrUndefined,
  deepEqual,
  deepMerge,
  getNamespaceFilterString,
  useNamespaceFilter,
  useLevelFilter,
  LogLevel,
  LogLevelAlias,
  LoggerContext,
  LoggerConsoleHandler,
  getGlobalContext,
  Logger,
  getTimestamp,
  formatMilliseconds,
  parseDate
};
//# sourceMappingURL=chunk-FLKB7XIS.js.map